export const ONBOARDING_COACH_CONTENT = {
  '/dashboard': {
    phase: 'Getting things ready',
    title: 'We are opening the right setup step',
    description: 'Afivio is checking your company progress. You do not need to choose anything on this screen.',
  },
  '/dashboard/setup/integration-selection': {
    phase: 'Choose an integration method',
    title: 'What platform is your website built with?',
    description: 'Select the integration method that matches your website. This helps ensure your data is attributed correctly.If you don’t sell products online, choose Manual setup in the control panel.',
  },
  '/dashboard/setup/help-choose-integration': {
    phase: 'Choose your connection',
    title: 'Follow the transaction',
    description: 'Select the system that confirms a successful order or payment. That is usually the best integration for your business.',
  },
  '/dashboard/setup/shopify-instructions': {
    phase: 'Shopify connection',
    title: 'No code is needed',
    description: 'Install Afivio from the Shopify App Store and approve the permissions. We will bring you back to the guided setup automatically.',
  },
  '/dashboard/add-company': {
    phase: 'Company profile',
    title: 'Use the website your customers visit',
    description: 'Enter your public domain, such as google.com. We’ll use it to create the custom portal link you share with affiliates.',
  },
  '/dashboard/[companyId]': {
    phase: 'Resume setup',
    title: 'Picking up where you left off',
    description: 'Afivio is finding the first unfinished task and will take you there automatically.',
  },
  '/dashboard/[companyId]/setup': {
    phase: 'Resume setup',
    title: 'Finding your next step',
    description: 'We are checking what is already complete. You will be redirected to the only action that needs your attention.',
  },
  '/dashboard/[companyId]/setup/currency': {
    phase: 'Business settings',
    title: 'Choose your reward currency',
    description: 'Use the currency in which you calculate affiliate commissions. Country controls the regional defaults and can be changed later.',
  },
  '/dashboard/[companyId]/setup/campaign': {
    phase: 'First campaign',
    title: 'Start with one clear offer',
    description: 'Describe what partners will promote and choose a commission you can sustain. You can refine every rule after launch.',
  },
  '/dashboard/[companyId]/setup/stripe': {
    phase: 'Stripe connection',
    title: 'Connect the account that receives payments',
    description: 'Use your main Stripe business account. Afivio will attribute eligible payments to the affiliate who referred the customer.',
  },
  '/dashboard/stripe-verify': {
    phase: 'Stripe connection',
    title: 'Keep this tab open for a moment',
    description: 'We are checking the secure response from Stripe. The next setup screen will open as soon as verification finishes.',
  },
  '/dashboard/[companyId]/setup/horoshop': {
    phase: 'Horoshop connection',
    title: 'Prepare the script and store token',
    description: 'Add the tracking script first, then paste your store domain and API token. Both are required before connection can be verified.',
  },
  '/dashboard/[companyId]/setup/wordpress': {
    phase: 'WordPress connection',
    title: 'Install the plugin before adding credentials',
    description: 'Upload and activate the Afivio plugin, then copy the Company ID and API Secret into its WordPress settings.',
  },
  '/dashboard/[companyId]/setup/add': {
    phase: 'Tracking setup',
    title: 'Choose how to connect your website',
    description: 'Use our API or tracking script, let our team help with the setup, or manage everything manually without connecting a website.',
  },
  '/dashboard/[companyId]/setup/verify': {
    phase: 'Final check',
    title: 'Verify the live website',
    description: 'Open the exact website address shown on this page. A successful visit confirms that Afivio can receive tracking data.',
  },
  '/dashboard/[companyId]/setup/skip-complete': {
    phase: 'Setup complete',
    title: 'Your manual workspace is ready',
    description: 'No website connection is required. Create offers, invite affiliates and record commissions directly in the dashboard.',
  },
};

export default ONBOARDING_COACH_CONTENT;
